export {};

declare let window: any;

window.moment = require('moment');

window.markdownNavigation = function(path) {
  if (window.routesService) {
    window.routesService.navigate(window.routesService.getPathParts(path));
  }
}

let markedLib = require('marked');
let renderer = new markedLib.Renderer();
renderer.link = (href, title, text) => {
  let isExternal = !!href.match(/^http.*/);
  let target = isExternal ? '_blank' : '_self';
  let isInternal = !isExternal && window.routesService && href.charAt(0) !== '/';
  if (isInternal) {
    href = window.routesService.makeRelativePathAbsolute(href);
  }
  let link = `<a target="${target}" href="${href}"`;
  if (isInternal) link += ` onclick="window.markdownNavigation('${href}'); return false"`;
  if (title) link += ` title="${title}"`;
  link += `>${text}</a>`;
  return link;
}
renderer.code = function(code, lang) {
  if (!code) return '';
  lang = lang || '';
  if (lang && lang !== 'no-highlight') {
    let grammar = window.Prism.languages[lang];
    if (grammar) code = window.Prism.highlight(code, grammar);
  } else {
    code = code.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    code = '<span>' + code + '</span>';
  }
  return `<pre class="language-${lang}"><code>${code}</code></pre>`;
}
markedLib.setOptions({renderer});
window.marked = function(str, opts, cb) {
  str = str || '';
  return markedLib(str, opts, cb);
}

window.WebCodeBeauty = require('exports-loader?WebCodeBeauty!./third-party/WebCodeBeauty.js');
window.ejs = require('exports-loader?ejs!../../node_modules/ejs/ejs.js');
window.lunr = require('lunr');
window.Clipboard = require('clipboard');




// WEBPACK FOOTER //
// ./src/app/vendor.ts